var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-8"},[_c('permit-list',{attrs:{"list-type":"active","title":"Active Permits","loading":_vm.loading}}),_vm._v(" "),_c('permit-list',{attrs:{"list-type":"expired","title":"Expired Permits","loading":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }